import { profileSectionConflicts, type Project } from "@proof/core";

/** Warns when a section mixes variables from different global profiles. */
export function ProfileConflicts({ project }: { project: Project }) {
  const conflicts = profileSectionConflicts(project);
  if (!conflicts.length) return null;
  return (
    <div className="ps-notice profile-conflicts" data-tone="warning" role="alert">
      <div>
      <strong>Each section can use only one global profile.</strong>
      <p>
        Saving is blocked until these sections are resolved. Move variables into
        separate sections (unmapped variables may stay), or use Generate Form to
        split them by profile.
      </p>
      <ul>
        {conflicts.map((conflict) => (
          <li key={conflict.groupId}>
            <strong>{conflict.groupName}</strong>: {conflict.profiles.join(", ")}
          </li>
        ))}
      </ul>
      </div>
    </div>
  );
}
